import { CHAR_CAP, STARTER_PLOT, TOKEN_BUDGET } from '@coderaw/runtime'
import { el } from '../lib/dom'

const API_LINES: readonly (readonly [string, string])[] = [
  ['draw(g, t, env)', 'export this. Called 15 times a second.'],
  ['g.cls(c)', 'clear the plot to palette colour c (0–15)'],
  ['g.pset(x, y, c)  g.pget(x, y)', 'one pixel'],
  ['g.line(x0, y0, x1, y1, c)', ''],
  ['g.rect(x, y, w, h, c)  g.rectfill(…)', ''],
  ['g.circ(x, y, r, c)  g.circfill(…)', ''],
  ['g.print(text, x, y, c)', 'a 3×5 font, 4 px per letter'],
  ['g.rnd(n)', 'random in [0, n), the same for every viewer'],
  ['t', 'seconds since the season began'],
  ['env.weather  env.intensity', "'snow' this week, 0 to 1"],
  ['env.light', '0 at midnight, 1 at noon'],
  ['env.here.cat  env.visitors', 'who is around (nobody yet in step 0)'],
]

const PALETTE_NAMES =
  '0 night · 1 soil · 2 pine · 3 brick · 4 wood · 5 stone · 6 ash · 7 snow · 8 lamp · 9 ember · 10 moss · 11 sky · 12 ice · 13 dusk · 14 blossom · 15 cream'

/** The `help api` card: everything a plot can call, on one screen. */
export const createApiCard = (): HTMLElement =>
  el(
    'details',
    { class: 'panel' },
    el('summary', {}, 'help api'),
    el(
      'dl',
      { class: 'api-list' },
      ...API_LINES.flatMap(([sig, note]) => [
        el('dt', {}, el('code', {}, sig)),
        el('dd', {}, note),
      ]),
    ),
    el('p', { class: 'panel-note' }, 'palette: ', PALETTE_NAMES),
    el(
      'p',
      { class: 'panel-note' },
      `budget: ${TOKEN_BUDGET} tokens, ${CHAR_CAP.toLocaleString()} characters. `,
      'Names, keywords, numbers and opening brackets cost 1. Comments, spaces, commas and closing brackets are free. Strings cost 1 per 16 characters.',
    ),
  )

/** The starter house, read-only. It has to be typed to be used. */
export const createExamplePanel = (): HTMLElement =>
  el(
    'details',
    { class: 'panel' },
    el('summary', {}, 'example plot'),
    el('p', { class: 'panel-note' }, 'Read it, then type your own. Paste is off on purpose.'),
    el('pre', { class: 'example-code' }, el('code', {}, STARTER_PLOT)),
  )
